import {HUMANIA_FORMS_EN, HUMANIA_FORMS_FR, ReferenceDocumentation} from './reference-documentation';

export const TABLE_CONTENT_FR = [
  {
    data: {
      name: 'Ressources Emma',
      isPdf: true,
    },
    children: [
      {
        data: {
          name: 'Guide de produit',
          fileName: ReferenceDocumentation.PRODUCT_GUIDE_FR,
          isPdf: true,
        },
        leaf: true,
      },
      {
        data: {
          name: 'Guide de tarification',
          fileName: ReferenceDocumentation.UNDERWRITING_GUIDE_FR,
          isPdf: true,
        },
        leaf: true,
      },
    ],
  },
  {
    data: {
      name: 'Formulaires Humania',
      isUrl: true,
    },
    children: [
      {
        data: {
          name: 'Formulaires Humania',
          href: HUMANIA_FORMS_FR,
          isUrl: true,
        },
        leaf: true,
      },
    ],
  },
];

export const TABLE_CONTENT_EN = [
  {
    data: {
      name: 'Emma Resources',
      isPdf: true,
    },
    children: [
      {
        data: {
          name: 'Product guide',
          fileName: ReferenceDocumentation.PRODUCT_GUIDE_EN,
          isPdf: true,
        },
        leaf: true,
      },
      {
        data: {
          name: 'Underwriting guide',
          fileName: ReferenceDocumentation.UNDERWRITING_GUIDE_EN,
          isPdf: true,
        },
        leaf: true,
      },
    ],
  },
  {
    data: {
      name: 'Humania forms',
      isUrl: true,
    },
    children: [
      {
        data: {
          name: 'Humania forms',
          href: HUMANIA_FORMS_EN,
          isUrl: true,
        },
        leaf: true,
      },
    ],
  },
];
